import { useState } from "react";

const PastYear2324 = () => {
    const [isHovering] = useState(false);
    
    const styles = {
        container: {
            height: "auto",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            color: "white"
        },
        content: {
            position: "relative" as "relative",
            height: "auto",
            maxHeight: "95%",
            width: "95%",
            maxWidth: "1280px",
            fontSize: "22px",
            fontFamily: "'Raleway', Arial",
            padding: "130px 0px",
            margin: "auto",
            verticalAlign: "middle",
            textAlign: "center" as "center",
        },
        contentAlt: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            //position: "relative",
            display: "block",
            height: "100%",
            width: "100%",
            color: "#FFF",
            fontSize: "20px",
            fontWeight: "300",
            fontFamily: "'Raleway', Arial, sans-serif",
            padding: "100px 0px",
            margin: "auto",
            verticalAlign: "middle",
            textAlign: "center" as "center",
        },
        sectionTitle: {
            fontSize: "32px",
            margin: "0px",
            fontWeight: "normal",
        },
        button: {
            margin: "10px",
            padding: "10px 20px",
            fontSize: "18px",
            backgroundColor: "#141619",
            color: "white",
            border: "1px solid #ddd",
            borderRadius: "8px",
            cursor: "pointer",
        },
        activeButton: {
            backgroundColor: "#050A44",
        },
    }

    return (
        <div className="container" style={styles.container}>
            <div className="content"
            style={{
                ...styles.content,
                color: "white",
                backgroundColor: "#141619",
                maxWidth: 1280,
                margin: "0px auto 0px",
            }}>
                <h1 style={{ color: "#1d77d7", fontSize: "60px", alignContent: "center", fontFamily: "'NCAA Missouri Tigers', Arial", }}>Jelly 2</h1>
                <p className="sectionTitle" style={styles.sectionTitle}>2023-2024</p>
                <br />
                <div>
                <img
                    src="/images/jelly2Photos/Exploded.png"
                    alt="exploded view"
                    style={{ 
                        padding: "clamp(15px, 5vw, 40px)", 
                        maxWidth: "100%",
                        width: "clamp(280px, 95vw, 900px)",
                        height: "auto",
                        marginBottom: "20px",
                        borderRadius: "8px",
                        backgroundColor: "#131c81",
                        objectFit: "contain" 
                    }}
                />
                </div>
                <img
                    src="/images/jelly2Photos/Front.png"
                    alt="front view"
                    style={{
                        maxWidth: "clamp(180px, 30vw, 300px)",
                        height: "auto",
                        verticalAlign: "middle",
                        padding: "clamp(10px, 2vw, 20px)",
                        borderRadius: "8px",
                        backgroundColor: "#131c81",
                        margin: "10px",
                        display: "inline-block"
                    }}
                />
                <img
                    src="/images/jelly2Photos/Iso.png"
                    alt="iso view"
                    style={{
                        maxWidth: "clamp(180px, 30vw, 300px)",
                        height: "auto",
                        verticalAlign: "middle",
                        padding: "clamp(10px, 2vw, 20px)",
                        margin: "clamp(5px, 2vw, 20px)",
                        borderRadius: "8px",
                        backgroundColor: "#131c81",
                        display: "inline-block"
                    }}
                />
                <img
                    src="/images/jelly2Photos/Side.png"
                    alt="side view"
                    style={{
                        maxWidth: "clamp(180px, 30vw, 300px)",
                        height: "auto",
                        verticalAlign: "middle",
                        padding: "clamp(10px, 2vw, 20px)",
                        borderRadius: "8px",
                        backgroundColor: "#131c81",
                        margin: "10px",
                        display: "inline-block"
                    }}
                />
                <br />
                <br />
                <br />
                <a href="Jelly2_Technical_Design_Report.pdf" style={{ width: "100%" }}>
                    <button style={{
                            ...styles.button,
                            ...( isHovering ? styles.activeButton : {}),
                        }}>
                            Jelly Technical Design Report
                    </button>
                </a>
            </div>
        </div>
    )
}

export default PastYear2324;